<div class="w-full  sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent">
    <div class="w-full">
<!-- ##########################################################  -->
<!-- ##########################################################  --> 
            <!-- ///////////////////////////////////////////// -->
            <!-- ///////////////////////////////////////////// -->          
                    <!-- ##########################################################  -->
                    <div class="grid grid-cols-2">       
                        <div>
                            <h2 class="prose prose-xl"><b>Detalle {{dteData.GLS  | titlecase}} </b>
                                <!-- 
                                <span *ngIf="payData.STATUS_PAYMENT == 'F'"><b style="color: rgb(28, 154, 3)"  >Pagado</b>      </span>
                                <span *ngIf="payData.STATUS_PAYMENT == 'P'"><b style="color: rgb(198, 172, 5)" >Pago Parcial</b></span>
                                <span *ngIf="payData.STATUS_PAYMENT == 'N'"><b style="color: rgb(169, 8, 8)"   >Pendiente</b>   </span>
                                -->
                            </h2> 
                        </div>
                       
                        <!-- ## -->
                        <div>
                            <button class="close" mat-button (click)="closeBtn()" > <mat-icon>close</mat-icon></button>         
                        </div>
                    </div>
                    <!-- ##########################################################  -->
            <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  -->
            <mat-divider class="py-2"></mat-divider>
            <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  -->             
            <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  -->             
            <div>
                <!--#######################-->
                <div class="w-full">   

                            <div >
                                <div >Rut: <b>{{dteData.RUT || '1-9'  |  rut:'DOTS_DASH'  }}</b></div>
                                <div >Razón Social: <b>{{dteData.RAZON_SOCIAL  | titlecase  }}</b></div>
                                <div >Giro: <b>{{dteData.GIRO_IMPRESO | titlecase  }}</b></div>
                            </div>
                            <div >
                                <div >Folio: <b>{{dteData.FOLIO  |  number }}</b></div>
                                <div >Fecha de Emisión: <b>{{ dteData.FECHA_EMISION |  date:'dd-MM-yyyy' }}</b></div>
                            </div>
                </div>
                <div class="grid grid-cols-4">   
                            <div class="w-1/2 ">Neto:   <b>{{ dteData.MNTNETO  |  currency:'CLP':'symbol-narrow' }}</b></div>
                            <div class="w-1/2 ">Exento: <b>{{ dteData.MNTEXE   |  currency:'CLP':'symbol-narrow' }}</b></div>
                            <div class="w-1/2 ">IVA:    <b>{{ dteData.IVA      |  currency:'CLP':'symbol-narrow' }}</b></div>
                            <div class="w-1/2 ">Total:  <b>{{ dteData.MNTTOTAL |  currency:'CLP':'symbol-narrow' }}</b></div>
                </div>                   
                <!--#######################-->        
                <br>
                <div >
                    <div >TrackID: <b style="color: rgb(6, 167, 22)">{{dteData.TRACK_ID   }}</b></div>
                    <div *ngIf="dteData.COD_DTE_TIPO == 'DTE';else BOLTIMESTAMP">Fecha recepción SII: <b style="color: rgb(6, 167, 22)">{{dteData.XML_ESTADO_ENVIO_CARATULA.RECEPCIONDTE?.TIMESTAMP}}</b></div>
                    <ng-template #BOLTIMESTAMP>   
                        <div >Fecha recepción SII: <b style="color: rgb(6, 167, 22)">{{dteData.XML_ESTADO_ENVIO_CARATULA?.fecha_recepcion}}</b></div>
                    </ng-template>
                    <!-- ################# -->
                        <span *ngIf="dteData.COD_RESPUESTA_ENVIO_DTE == 'OK'; else errDTE">
                                    <div >Respuesta Caratula : <b >{{dteData.RESPUESTA_ENVIO_CARATULA       }}</b></div>
                                    <div >Respuesta DTE      : <b >{{dteData.RESPUESTA_ENVIO_DTE            }}</b></div>
                        </span>
                        <ng-template #errDTE>   
                            <span *ngIf="dteData.COD_RESPUESTA_ENVIO_DTE == 'RCH' || dteData.COD_RESPUESTA_ENVIO_DTE == 'RSC'; else errWAR " >
                                <div >Respuesta Caratula : <b style="color: rgb(217, 9, 9)">{{dteData.RESPUESTA_ENVIO_CARATULA       }}</b></div>
                                <div >Respuesta DTE      : <b style="color: rgb(217, 9, 9)">{{dteData.RESPUESTA_ENVIO_DTE            }}</b></div>
                            </span>  
                            <ng-template #errWAR>   
                                <span >
                                    <div >Respuesta Caratula : <b style="color: rgb(231, 158, 10)">{{dteData.RESPUESTA_ENVIO_CARATULA       }}</b></div>
                                    <div >Respuesta DTE      : <b style="color: rgb(231, 158, 10)">{{dteData.RESPUESTA_ENVIO_DTE            }}</b></div>
                                </span>                                  
                            </ng-template>
                        </ng-template>
                    <!-- ################# -->

                    <div *ngIf="dteData.COD_DTE_TIPO == 'DTE';else BOLFILE">Caratula           : <b style="color: rgb(6, 14, 167)">{{dteData.XML_ESTADO_ENVIO_CARATULA?.RECEPCIONDTE?.FILE}}</b></div>
                    <ng-template #BOLFILE>   
                        <div >Caratula           : <b style="color: rgb(6, 14, 167)">{{dteData.XML_ESTADO_ENVIO_CARATULA?.file}}</b></div>
                    </ng-template>
                    <!--$$-->
                    <div *ngIf="dteData.COD_DTE_TIPO == 'DTE';else BOLRUTSENDER">Rut Autorizado     : <b style="color: rgb(6, 14, 167)">{{dteData.XML_ESTADO_ENVIO_CARATULA?.RECEPCIONDTE?.RUTSENDER  |  rut:'DOTS_DASH' }}</b></div>
                    <ng-template #BOLRUTSENDER>   
                        <div >Rut Autorizado     : <b style="color: rgb(6, 14, 167)">{{dteData.XML_ESTADO_ENVIO_CARATULA?.rut_envia |  rut:'DOTS_DASH' }}</b></div>
                    </ng-template>
                </div>                
                <!--#######################-->                     
        </div>
        <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  -->             
        <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  -->  
             <div *ngIf="errorDTE.length > 0">
            <br>
                <h2 class="prose prose-xl"><b>Error </b></h2>
                <span  *ngFor="let e of errorDTE">
                 <b style="color: rgb(169, 8, 8)">{{e.err}}</b>
                </span>
             </div>
             <!--##-->
             <div *ngIf="errorBOL.length > 0">
                <br>
                    <h2 class="prose prose-xl"><b>Error </b></h2>
                    <span  *ngFor="let e of errorBOL">
                     <b style="color: rgb(169, 8, 8)">{{e.err}}</b> <br>
                     <b style="color: rgb(8, 40, 169)">{{e.det}}</b>
                    
                    </span>
                 </div>             
            
        <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  -->             
        <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  -->               

    <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  -->  
            <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  -->             
<!-- ##########################################################  -->
<!-- ##########################################################  --> 
    </div>
</div>    